import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconoirLogIn } from '@ey-xd/motif-icon';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';
import { ActivatedRoute, Router } from '@angular/router';
import { FULL_LOGIN_ROUTE } from '@routes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [MotifIconModule, MotifButtonModule, TranslatePipe],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent {
  public logInIcon = IconoirLogIn;
  #router: Router = inject(Router);
  #route = inject(ActivatedRoute);

  public isLogoutByTimeout = false;

  constructor() {
    this.#route.queryParamMap.subscribe(params => {
      const sessionTimeoutParam = params.get('sessionTimeout');
      this.isLogoutByTimeout = sessionTimeoutParam !== null;
    });
  }

  async login() {
    await this.#router.navigate([FULL_LOGIN_ROUTE]);
  }
}
